/**
 * Indexing runs (LAR-252) are finalised by whichever list is watching them — the files
 * tab, the Workspaces page content search or global search — and more than one of those
 * can be mounted at once (the search dialog opens on top of the files tab). Each poller
 * must therefore agree with the others on which runs are already dealt with, so a run is
 * finalised once and reported once. Ids live for the life of the tab; a run id is only
 * ever produced by an accepted rerun, so the set stays small.
 */
const handledOperations = new Set<string>();

/** True when some poller in this tab has already finalised or reported this run. */
export const hasHandledIndexingOperation = (operationId: string): boolean =>
  handledOperations.has(operationId);

/**
 * Claims a run for the caller. Returns false when another poller got there first, in
 * which case the caller must not finalise or toast.
 */
export const claimIndexingOperation = (operationId: string): boolean => {
  if (handledOperations.has(operationId)) return false;
  handledOperations.add(operationId);
  return true;
};
